<template>
    <div class="login-wrapper relative" id="register">
      {{startChat}}
        <div class="container">
            <div class="row logo-row justify-content-center">
                <div class="col-md-4">
                </div>
            </div>
            <div class="row form-row">
                <div class="col-md-12">
                    <Card contentSpacing="none">
                        <div class="row row-eq-height">
                            <div class="col-md-6 login-illustration d-none d-md-block">
                                <div class="login-side">
                                    <div class="flex-content">
                                        <div class="row justify-content-center">
                                            <div class="col-md-6 text-center">
                                                <img src="@/assets/img/login-img-1.png" class="width-100 relative" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="login-side break-after">
                                    <div class="form-branding"><img src="@/assets/img/apostle_logo.png" class="width-100 relative" /></div>
                                    <div class="chat-wrapper" id="scrollWrap">
                                        <div class="width-100 relative">
                                            <div class="chat-row apostle-chat" :key="index" v-for="(message, index) in messages" v-bind:class="{'user-chat': message.me}">
                                                <div class="chat-message-wrap">
                                                    <div class="chat-message" v-html="message.message"></div>
                                                </div>
                                            </div>
                                            <div class="chat-row button-row">
                                                <Button width="expand" :key="index" v-for="(buttonOption, index) in buttonOptions" v-on:click.native="buttonPressed(buttonOption)">{{buttonOption.text}}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
        <Modal v-if="showForm">
            <form>
                <Input type="text" label="First name" placeholder="First name" v-model="form.first" />
                <Input type="text" label="Last name" placeholder="Last name" v-model="form.last" />
                <Input type="text" label="Email address" :value="invite.email" placeholder="Email" disabled />
                <Input type="password" label="Password" placeholder="Password" v-model="form.password" />
                <Input type="password" label="Password confirmation" placeholder="Password" />
                <Input type="checkbox" label="I agree with the <a>User License Agreement</a> of Apostle Connect."/>
            </form>
            <template v-slot:modal-actions>
                <Button class="float-right" @click.native="buttonPressed({value:'proceed'})">Proceed</Button>
            </template>
        </Modal>
    </div>
</template>
<script>
    import Input from "../../../components/Input/Input"
    import Card from "../../../components/Card/Card"
    import Button from "../../../components/Button/Button"
    import chatbot from "./chatbot";
    import Modal from "../../../components/Modal/Modal";
    import Context from '@/models/Context';
    import Invite from '@/models/core/Invite';
    import { mapActions, mapGetters } from "vuex";

    let messageInterval = 350;
    export default {
        name: 'register',
        components: {
            Modal,
            Input,
            Card,
            Button,
        },
        props: [],
        data () {
            return {
                messages: [],
                buttonOptions: [],
                showForm: false,
                acceptToken: '',
                form: {
                  first: '',
                  last: '',
                  password: ''
                },
                currentStep: ''
            }
        },
        computed: {
          invite: function() {
            if (!this.isLoading) {
              const invite = Invite.query()
              .where(invite => {
                return invite.token === this.acceptToken;
              })
              .first();

              return invite;
            } else {
              return null;
            }
          },

          isLoading: function() {
            return this._isLoading();
          },

          startChat: function() {
            if (!this.isLoading && this.currentStep === '') {
              if (this.invite) {
                if (this.invite.state === 'accepted') {
                  this.loadChat(chatbot['step_accepted']);
                } else {
                  this.loadChat(chatbot['start']);
                }
              }
            }

            return null;
          }
        },
        created() {
          this.acceptToken = this.$route.params.token;
        },
        mounted () {
            this._inviteFind(this.acceptToken);
        },
        methods: {
            ...mapActions({
              _inviteFind: 'entities/invites/findByToken',
              _inviteAccept: 'entities/invites/accept',
              _userGet: 'entities/users/get',
              _userUpdate: 'entities/users/update'
            }),
            ...mapGetters({
              _isLoading: 'isLoading'
            }),
            buttonPressed(option){
                if(option.value === 'fill-in-form'){
                    this.showForm = true;
                } else if(option.value === 'step5') {
                  this.$router.push({ path: '/admin/dashboard' });
                } else if (option.value === 'to_login' || option.value === 'to_reset') {
                  this.messages.push({
                      message: option.response,
                      me: true
                  });
                  this.buttonOptions = [];
                  setTimeout(() => {
                  this.loadChat(chatbot['change_location']);
                  }, 350);

                  setTimeout(() => {
                    this.$router.push({ path: option.value === 'to_reset' ? '/login/reset' : '/login' });
                  }, 1500);
                }
                else if(option.value==='proceed'){
                   this._inviteAccept(this.invite).then(() => {
                     this._userGet().then(() => {
                       const user = Context.query()
                        .where(context => {
                          return context.id === 'current';
                        })
                        .with('user')
                        .first().user;

                        user.firstName = this.form.first;
                        user.lastName = this.form.last;
                        user.password = this.form.password;

                        this._userUpdate(user).then(() => {
                          this.showForm = false;
                        }).then(() => {
                          this.loadChat(chatbot['step2']);
                        });
                      })
                   });
                } else {
                    this.messages.push({
                        message: option.response,
                        me: true
                    });
                    this.buttonOptions = [];
                    setTimeout(()=>{
                        this.loadChat(chatbot[option.value]);
                    }, messageInterval)
                }

            },
            loadChat(input){
              this.currentStep = input;

                input.messages.forEach((message, index)=>{
                    message.message = message.message.replace('<first_name>', this.form.first);
                    setTimeout(()=>{
                       this.messages.push(message);
                        this.scrollTo();
                    }, messageInterval*index)
                });
                setTimeout(()=>{
                    this.buttonOptions = input.options;
                    this.scrollTo();
                }, input.messages.length*messageInterval);

            },
            scrollTo() {
                var element = document.getElementById("scrollWrap");
                var duration = 200;
                if (!element) {
                    return
                }
                var target = element.scrollHeight
                target = Math.round(target)
                duration = Math.round(duration)
                if (duration < 0) {
                    return false
                }
                if (duration === 0) {
                    element.scrollTop = target
                    return true
                }

                var start_time = Date.now()
                var end_time = start_time + duration

                var start_top = element.scrollTop
                var distance = target - start_top

                // based on http://en.wikipedia.org/wiki/Smoothstep
                var smooth_step = function (start, end, point) {
                    if (point <= start) { return 0 }
                    if (point >= end) { return 1 }
                    var x = (point - start) / (end - start) // interpolation
                    return x * x * (3 - 2 * x)
                }

                // This is to keep track of where the element's scrollTop is
                // supposed to be, based on what we're doing
                var previous_top = element.scrollTop

                // This is like a think function from a game loop
                var scroll_frame = function () {
                    if (element.scrollTop !== previous_top) {
                        return false
                    }

                    // set the scrollTop for this frame
                    var now = Date.now()
                    var point = smooth_step(start_time, end_time, now)
                    var frameTop = Math.round(start_top + (distance * point))
                    element.scrollTop = frameTop;

                    // check if we're done!
                    if (now >= end_time) {
                        return true
                    }

                    // If we were supposed to scroll but didn't, then we
                    // probably hit the limit, so consider it done; not
                    // interrupted.
                    if (element.scrollTop === previous_top && element.scrollTop !== frameTop) {
                        return true
                    }
                    previous_top = element.scrollTop
                    // schedule next frame for execution
                    setTimeout(scroll_frame, 0);
                }
                // boostrap the animation process
                setTimeout(scroll_frame, 0);
            }
        }
    }

</script>
<style src="./Register.scss" scoped lang="scss"></style>

